import { streamingTimelineDuration } from './streamingTimelineDuration'
import { timelineFinishedSummary } from './timelineFinishedSummary'
import { timelineFinishedDuration } from './timelineFinishedDuration'

export function activityTimelineHeadline(input) {
  const {
    publicView,
    workStatus,
    runId,
    view,
    hasArtifacts,
    publicActivity,
    hasPublicTimeline,
    streaming = false,
    now = Date.now(),
    activity = [],
    thoughtSummary = null,
    hasResponseText = false,
    clientRunStartedAt = null,
    clientRunCompletedAt = null,
  } = input
  const summary = timelineFinishedSummary({
    publicView,
    workStatus,
    runId,
    view,
    hasArtifacts,
    thoughtSummary,
    streaming,
  })
  const duration = streaming
    ? streamingTimelineDuration({
        publicActivity,
        activity,
        publicView,
        now,
        thoughtSummary,
        hasResponseText,
        clientRunStartedAt,
      })
    : timelineFinishedDuration({
        hasPublicTimeline,
        publicActivity,
        publicView,
        view,
        clientRunStartedAt,
        clientRunCompletedAt,
      })
  return { summary, duration }
}
